import React, { useState } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../../components/MCSSpace';
import { adminService } from '../../../services/admin.service';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { UserRole } from '../../../_constants/UserRole';
import AdditionalEntitlements from '../Components/AdditionalEntitlements';

const UserAccessDialog = (props) => {

    const [loading, setLoading] = useState(false);
    const [isSubscriptionManager, setSubscriptionManager] = useState(false);
    const [isLibraryManager, setIsLibraryManager] = useState(false);
    const [isSifManager, setIsSifManager] = useState(false);
    const [hasVisaInternalExtendedAccess, setVisaInternalExtendedAccess] = useState(false);
    const [isVmidParticipation, setIsVmidParticipation] = useState(false);
    const [isVmidFileUpload, setIsVmidFileUpload] = useState(false);
    const [isAcquirerVmid, setIsAcquirerVmid] = useState(false);
    const [isCompnayAdmin, setIsCompanyAdmin] = useState(false);
    const [isVstsL0, setIsVstsL0] = useState(false)
    const [vstsEntitlements, setVstsEntitlements] = useState(1)
    const [isVstsWorkflowAdmin, setIsVstsWorkflowAdmin] = useState(false);
    const [hasReportingExport, setHasReportingExport] = useState(false);

    const currentUser = props.currentUser.user;

    const toggleSubscriptionManager = () => {
        setSubscriptionManager(!isSubscriptionManager);
    }

    const toggleSifManager = () => {
        setIsSifManager(!isSifManager);
    }

    const toggleLibraryManager = () => {
        setIsLibraryManager(!isLibraryManager);
    }

    const toggleVisaInternalAccess = () => {
        setVisaInternalExtendedAccess(!hasVisaInternalExtendedAccess);
    }

    const toggleVmidParticipation = () => {
        setIsVmidParticipation(!isVmidParticipation);
    }

    const toggleVmidFileUpload = () => {
        setIsVmidFileUpload(!isVmidFileUpload);
    }

    const toggleAcquirerVmid = () => {
        setIsAcquirerVmid(!isAcquirerVmid);
    }

    const toggleIsCompanyAdmin = () => {
        setIsCompanyAdmin(!isCompnayAdmin);
    }

    const toggleVstsL0 = () => {
        setIsVstsL0(!isVstsL0)
    }

    const handleAdminVstsEntitlementsRadioBtnChange = (e) => {
        setVstsEntitlements(parseInt(e.target.value))
    }

    const toggleVstsWorkflowAdmin = () => {
        setIsVstsWorkflowAdmin(!isVstsWorkflowAdmin)
    }

    const toggleHasReportingExport = () => {
        setHasReportingExport(!hasReportingExport);
    }

    const userDto={
        volUserId: null,
        organizationId: null,
        entitleId: null,
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        isSubscriptionManager: null,
        isCompnayAdmin: null,
        IsSifManager: null,
        isLibraryManager: null,
        jobTitle: null,
        countryName: null,
        countryCode: null,
        city: null,
        state: null,
        hasVisaInternalExtendedAccess: null,
        isVmidParticipation: null,
        isVmidFileUpload: null,
        isAcquirerVmid: null,
        adminVstsEntitlement: null,
        hasVstsL0: null,
        isVstsWorkflowAdmin: null,
        hasReportingExport: null
    }

    const approveUser = async () => {
        setLoading(true);
        let user = props.user;
        userDto.volUserId = user.userId;
        userDto.organizationId = user.organizationId;
        userDto.firstName = user.firstName;
        userDto.lastName = user.lastName;
        userDto.phone = user.phone;
        userDto.email = user.email;
        userDto.entitleId = user.roleId;
        userDto.jobTitle = user.jobTitle;
        userDto.countryName = user.countryName;
        userDto.city = user.city;
        userDto.state = user.state;
        userDto.countryCode = user.countryCode

        if (user.roleId === UserRole.SuperAdmin_Entitlement || user.roleId === UserRole.ToolsAdmin_Entitlement) {
            userDto.adminVstsEntitlement = vstsEntitlements;
        }

        if (user.roleId === UserRole.ToolsAdmin_Entitlement) {
            userDto.isVstsWorkflowAdmin = isVstsWorkflowAdmin;
            userDto.hasReportingExport = hasReportingExport;
        }
        if (user.roleId === UserRole.StoreAdmin_Entitlement || user.roleId === UserRole.ToolsAdmin_Entitlement) {
            userDto.isLibraryManager = isLibraryManager;
        }

        if (user.roleId === UserRole.StoreAdmin_Entitlement) {
            userDto.isSifManager = isSifManager;
        }

        if (user.roleId === UserRole.UserExternal_Entitlement) {
            userDto.isSubscriptionManager = isSubscriptionManager;
            userDto.isAcquirerVmid = isAcquirerVmid;
            userDto.isCompnayAdmin = isCompnayAdmin;
        }

        if (user.roleId === UserRole.UserInternal_Entitlement) {
            userDto.hasVisaInternalExtendedAccess = hasVisaInternalExtendedAccess;
            userDto.hasVstsL0 = hasVisaInternalExtendedAccess && isVstsL0
        }

        if (user.roleId === UserRole.UserInternal_Entitlement) {
            userDto.isVmidFileUpload = isVmidFileUpload;
            userDto.isVmidParticipation = isVmidParticipation;
        }

        const Response = await adminService.ApproveUser(userDto);
        console.log(Response)

        if (Response && Response.success) {
            props.alertObj.setSuccessMessage(Response.result);
        } else {
            props.alertObj.setErrorMessage("User failed to be approved.");
        }

        props.tablesRefresh();
        props.setSelectedUser(null)

        //Reset flags
        setSubscriptionManager(false);
        setIsCompanyAdmin(false);
        setIsLibraryManager(false);
        setIsSifManager(false);
        setVisaInternalExtendedAccess(false);
        setIsVmidParticipation(false);
        setIsVmidFileUpload(false);
        setIsAcquirerVmid(false);
        setHasReportingExport(false);

        setLoading(false);
    }
    return (
        <>
            {loading &&
                <MCSOverlayLoading />}
            <Dialog
                aria-describedby="Accept User Access Request"
                onExit={() => { }}
                open={props.openUserAccessDialog}
                titleId="dialog-manage-user"
            >
                <DialogCardHead>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Access Request - User Details</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Row noGutter key={1}>
                            <Col noTopGutter noGutter lg={6}>
                                <b>Region</b><br />
                                {props.user && props.user.regionName}
                            </Col>
                            <Col noTopGutter noGutter lg={6}>
                                <b>User ID</b><br />
                                {props.user && props.user.userId}
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={2}>
                            <Col noTopGutter noGutter lg={6}>
                                <b>Country</b><br />
                                {props.user && props.user.countryName}
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <b>Name</b><br />
                                {props.user && props.user.firstName + " " + props.user.lastName}
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={3}>
                            <Col noTopGutter noGutter lg={6}>
                                <b>Organization</b><br />
                                {props.user && props.user.organizationName}
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <b>Email</b><br />
                                {props.user && props.user.email}
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={4}>
                            <Col noTopGutter noGutter lg={6}>
                                <b>BID</b><br />
                                {props.user && props.user.bid}
                            </Col>

                            <Col noTopGutter noGutter lg={6}>
                                <b>Role</b><br />
                                {props.user && props.user.roleName}
                            </Col>
                        </Row>
                        <MCSSpace />
                        <MCSSpace />

                        <AdditionalEntitlements user={props.user} setUser={props.setUser} currentUser={currentUser}
                            toggleLibraryManager={toggleLibraryManager} toggleSifManager={toggleSifManager}
                            toggleSubscriptionManager={toggleSubscriptionManager} toggleVisaInternalAccess={toggleVisaInternalAccess}
                            toggleVmidParticipation={toggleVmidParticipation} toggleVmidFileUpload={toggleVmidFileUpload}
                            toggleAcquirerVmid={toggleAcquirerVmid} toggleCompanyAdmin={toggleIsCompanyAdmin}
                            toggleVstsL0={toggleVstsL0} handleAdminVstsEntitlementsRadioBtnChange={handleAdminVstsEntitlementsRadioBtnChange}
                            toggleVstsWorkflowAdmin={toggleVstsWorkflowAdmin} toggleHasReportingExport={toggleHasReportingExport} 
                            vstsEntitlements={vstsEntitlements}
                        />

                    </Grid>
                    <MCSSpace />
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => { props.setSelectedUser(null) }}
                        >
                            Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                approveUser()
                            }}
                        >
                            Approve
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>

    )
}


export default UserAccessDialog